import './lib/uuid';
import { Factory } from 'rosie';

Factory.define('AgentSearchResult').extend('Uuid');

Factory.define('AgentSearchResultWithDefaults')
  .attr('id', 'search-id')
  .attr('hits', () => [Factory.attributes('AgentSearchHitWithDefaults')]);
